<template>
  <svg viewBox="2.5 2.5 45 45">
    <g id="icons"></g>
    <g id="Layer_3">
      <g>
        <g>
          <rect x="12.57" y="7" class="st0" width="24.68" height="4.78" />
          <path
            class="st1"
            d="M37.8,12.33H12.02V6.45H37.8V12.33z M13.12,11.23H36.7V7.55H13.12V11.23z"
          />
        </g>
        <g>
          <rect x="12.57" y="11.75" class="st0" width="24.68" height="31.16" />
          <path
            class="st1"
            d="M37.8,43.46H12.02V11.2H37.8V43.46z M13.12,42.36H36.7V12.3H13.12V42.36z"
          />
        </g>
        <g>
          <path
            class="st0"
            d="M41.91,37.62c0.08,0.08-21.12,5.96-21.17,5.92c-5.02-5.02-8-31.83-8-31.83l24.51,0.05
				C37.25,11.75,37.54,33.25,41.91,37.62z"
          />
          <path
            class="st1"
            d="M20.7,44.08c-0.14,0-0.24-0.05-0.35-0.16c-5.1-5.1-8.03-31.06-8.16-32.16l-0.07-0.61l25.67,0.05l0.01,0.54
				c0,0.21,0.33,21.32,4.5,25.48l0.23,0.22l-0.08,0.31c-0.1,0.37-0.1,0.37-9.62,3.03c-4.85,1.35-10.01,2.77-11.5,3.17
				C21.03,44.03,20.84,44.08,20.7,44.08z M13.36,12.25c0.47,3.95,3.27,25.78,7.57,30.67c2.3-0.59,16.62-4.58,20.04-5.59
				c-3.63-5.12-4.18-21.74-4.25-25.04L13.36,12.25z"
          />
        </g>
        <circle class="st1" cx="25.01" cy="9.12" r="0.96" />
        <g>
          <path
            d="M27.97,32.13c-0.39,0.12-0.69,0.39-0.86,0.72c-0.18,0.33-0.24,0.73-0.12,1.12s0.39,0.69,0.73,0.85
				c0.33,0.17,0.73,0.22,1.12,0.1c0.39-0.12,0.7-0.4,0.88-0.73c0.17-0.33,0.22-0.73,0.1-1.12s-0.39-0.69-0.72-0.86
				C28.77,32.06,28.36,32.01,27.97,32.13z"
          />
          <path
            d="M27.61,16.3c-1.13-0.41-2.46-0.35-3.67,0.03c-0.9,0.28-1.72,0.74-2.37,1.28c-0.65,0.55-1.14,1.21-1.38,1.85l0.98,1.27
				l0.11-0.04c0.17-0.51,0.59-1.02,1.14-1.45c0.55-0.43,1.22-0.8,1.96-1.03c1.01-0.32,1.89-0.31,2.57-0.02
				c0.68,0.28,1.15,0.83,1.38,1.57c0.12,0.39,0.16,0.74,0.12,1.09c-0.09,0.69-0.38,1.36-0.81,2.05c-0.2,0.35-0.42,0.72-0.62,1.12
				c-0.41,0.79-0.8,1.69-0.95,2.78c-0.15,1.1-0.07,2.41,0.44,4.02l1.92-0.6c-0.23-0.75-0.37-1.44-0.41-2.04
				c-0.08-1.22,0.11-2.22,0.47-3.06c0.35-0.84,0.8-1.6,1.19-2.32c0.21-0.35,0.36-0.73,0.49-1.11c0.25-0.78,0.32-1.61,0-2.62
				C29.7,17.6,28.74,16.72,27.61,16.3z"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconDatumKalender extends Vue {}
</script>

<style scoped type="text/css">
.st0 {
  fill: none;
}

.st1 {
  fill: #1d1d1c;
}
</style>
